module.exports = __webpack_public_path__ + "img/notificationssettings.8cab84ca.png";